import alert from '@/plugins/alert'
import { BoardingClass } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    items: [],
    count: 0,
    pageText: '',
    itemsPerPage: 10,
    filterParams: {},
    loading: false,
    //
    item: {},
  },
  actions: {
    search({ commit, state, dispatch }, query) {
      const filterParams = {
        _limit: state.itemsPerPage,
        ...query,
      }
      commit('changeState', { filterParams })
      dispatch('requestPageSettings', {})
    },
    async requestPageSettings({ state, commit }, { page, itemsPerPage }) {
      state.loading = true
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      const filterParams = {
        ...state.filterParams,
        _sort: 'name:ASC',
        _start: (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
      }
      const [count, items] = await Promise.all([BoardingClass.count(filterParams), BoardingClass.search(filterParams)])
      commit('changeState', { items, count, itemsPerPage, filterParams })

      const pageStart = (page - 1) * itemsPerPage + 1
      let pageStop = page * itemsPerPage
      pageStop = pageStop > count || pageStop === -1 ? count : pageStop
      const pageText = `${pageStart}-${pageStop} trên ${count}`
      commit('setPageText', pageText)
      state.loading = false
    },
    async create(_, params) {
      try {
        await BoardingClass.create(params)
        alert.success('Tạo lớp bán trú thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async update(_, { id, ...params }) {
      try {
        await BoardingClass.update(id, params)
        alert.success('Cập nhật lớp bán trú thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async remove(_, id) {
      try {
        await BoardingClass.remove(id)
        alert.success('Xoá lớp bán trú thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    //
    async fetchOne({ commit }, id) {
      const item = await BoardingClass.fetchOne(id)
      commit('changeState', { item })
    },
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
  },
  getters: {
    items: state => state.items,
    count: state => state.count,
    pageText: state => state.pageText,
    itemsPerPage: state => state.itemsPerPage,
    loading: state => state.loading,
    // 
    item: state => state.item
  },
}
